import { useParams } from 'react-router-dom'

/**
 * Legacy route: /t/:ticketId
 * 
 * ⚠️ DEPRECATED: This route is no longer supported.
 * QR codes should use /mesa/:mesaId instead.
 * 
 * This route is kept for backward compatibility but will show an error.
 */
export function TableEntry() {
  const { ticketId } = useParams<{ ticketId: string }>()

  return (
    <div className="p-4 max-w-md mx-auto">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <h2 className="text-lg font-semibold text-yellow-800 mb-2">
          Ruta no soportada
        </h2>
        <p className="text-yellow-700 mb-2">
          La ruta <code className="bg-yellow-100 px-1 rounded">/t/:ticketId</code> ya no está disponible.
        </p>
        <p className="text-yellow-700">
          Por favor, use el código QR de la mesa o acceda mediante <code className="bg-yellow-100 px-1 rounded">/mesa/:mesaId</code>.
        </p>
        {ticketId && (
          <p className="text-sm text-yellow-600 mt-2">
            Ticket ID recibido: {ticketId}
          </p>
        )}
      </div>
    </div>
  )
}
